import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Paper, TextField, Button, Typography } from "@material-ui/core";
import { connect } from "react-redux";
import Axios from "axios";
import jwtDecode from "jwt-decode";

import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";

import { url } from "../../../config/config";
import logo from "../../..//Assets/Images/logo.png";
import AdminBackground from "../../../Assets/Images/AdminBackground.jpg";
import { adminLogin } from "../../../redux/action/action";
import { useStyles } from "./AdminLogin.css";
import FormLoader from "../../../Component/FormLoader/FormLoader";

class AdminLogin extends Component {
  state = {
    data: {
      email: "",
      password: "",
    },
    token: "",
    emailError: "",
    passwordError: "",
    showPassword: false,
    loading: false,
  };

  handleChange = (e) => {
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.value },
    });
  };

  showPassword = () => {
    return (
      <VisibilityIcon
        style={{ cursor: "pointer" }}
        onClick={() => this.setState({ showPassword: true })}
      />
    );
  };

  hidePassword = () => {
    return (
      <VisibilityOffIcon
        style={{ cursor: "pointer" }}
        onClick={() => this.setState({ showPassword: false })}
      />
    );
  };

  checkError = (EmailError, PasswordError) => {
    let emailError = EmailError;
    let passwordError = PasswordError;

    if (this.state.data.password.length < 8) {
      passwordError = "Password must be minimum of 8 characters";
    }

    if (emailError || passwordError) {
      this.setState({
        emailError,
        passwordError,
      });
      return true;
    } else {
      this.setState({
        emailError: "",
        passwordError: "",
      });
      return false;
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    let errorStatus = this.checkError();
    if (errorStatus === false) {
      this.setState({ loading: true });
      const response = await Axios.post(`${url}/api/auth`, this.state.data);
      if (response.data.emailError || response.data.passwordError) {
        this.setState({ loading: false });
        this.checkError(response.data.emailError, response.data.passwordError);
      } else {
        if (response.data.token) {
          this.setState({
            token: response.data.token,
          });
        }
      }
    }

    if (this.state.token) {
      try {
        let data = jwtDecode(this.state.token);
        if (data.isAdmin) {
          this.props.adminLogin(this.state.token);
        } else {
          this.setState({ loading: false });
          this.checkError(
            "Invalid email or password",
            "Invalid email or password"
          );
        }
      } catch (error) {}
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div
        className={classes.root}
        style={{
          backgroundImage: `url(${AdminBackground})`,
        }}
      >
        <Paper className={classes.paper}>
          <form onSubmit={this.handleSubmit}>
            <Typography variant="h5" className={classes.title}>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <img src={logo} alt="logo" style={{ width: 40, height: 30 }} />
                Digi-Book
              </div>
              <div>
                <strong>Admin Login</strong>
              </div>
            </Typography>

            <TextField
              name="email"
              type="email"
              label="Email or Username"
              fullWidth
              required
              margin="normal"
              variant="outlined"
              placeholder="Enter username or password"
              error={this.state.emailError ? true : false}
              helperText={this.state.emailError}
              style={{ outline: "none" }}
              InputProps={{
                classes: {
                  root: classes.inputRoot,
                  notchedOutline: classes.notchedOutline,
                  focused: classes.focused,
                },
              }}
              InputLabelProps={{
                classes: {
                  root: classes.labelRoot,
                  focused: classes.labelFocused,
                },
                shrink: true,
              }}
              value={this.state.data.email}
              onChange={this.handleChange}
            />

            <TextField
              name="password"
              type={this.state.showPassword ? "text" : "password"}
              label="Password"
              fullWidth
              required
              margin="normal"
              variant="outlined"
              error={this.state.passwordError ? true : false}
              helperText={this.state.passwordError}
              style={{ outline: "none" }}
              InputProps={{
                classes: {
                  root: classes.inputRoot,
                  notchedOutline: classes.notchedOutline,
                  focused: classes.focused,
                },
                endAdornment: this.state.showPassword
                  ? this.hidePassword()
                  : this.showPassword(),
              }}
              InputLabelProps={{
                classes: {
                  root: classes.labelRoot,
                  focused: classes.labelFocused,
                },
                shrink: true,
              }}
              value={this.state.data.password}
              onChange={this.handleChange}
            />

            <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                variant="outlined"
                type="submit"
                className={classes.buttonStyle}
              >
                Login
              </Button>
              {this.state.loading && <FormLoader />}
            </div>
            <br />
          </form>
        </Paper>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    adminLogin: (token) => {
      dispatch(adminLogin(token));
    },
  };
};

export default connect(
  null,
  mapDispatchToProps
)(withStyles(useStyles)(AdminLogin));
